/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext } from "react";

import { EthContext } from "../contexts/ethContext";

export default function useEthContext() {
  return useContext(EthContext);
}
